const holders = new Set();
let pending = null;

export function holdRecordForm(id, active) {
  if (active) holders.add(id);
  else holders.delete(id);
}

export function recordFormNeedsSession() {
  return holders.size > 0;
}

export function waitForSessionResume() {
  if (!pending) {
    let resolve;
    let reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    pending = { promise, resolve, reject };
    window.dispatchEvent(new CustomEvent('session-expired'));
  }
  return pending.promise;
}

export function resumeSession() {
  const current = pending;
  pending = null;
  current?.resolve();
}

export function cancelSessionResume(message) {
  const current = pending;
  pending = null;
  const error = /** @type {Error & { sessionCancelled: boolean }} */ (
    new Error(message || 'Sign in again to save this form.')
  );
  error.sessionCancelled = true;
  current?.reject(error);
}
